$(function() {   
  $(".ddbox .radio").on('click',function(event){

    var parent = $(this).parent(".ddbox");
    $(".ddbox").not(parent).removeClass("active");
    //parent.toggleClass("active");

    if($('input[name="location"]',this).val() == 'Home or Office'){
      $(this).parent(".ddbox").addClass("active");
      $(".store-result").text('');
      $("input[name='contact[location]']").val('Home or Office');
      var location = $('input[name="contact[location]"]').val();

      if (location == 'Home or Office' ){
        $(".dropdowns span").removeClass("selected");
        $(".dropdowns").hide();
        $('.location-dependent').show();
        $('.location-dependent input').show();

      } else {
        $('.location-dependent').hide(); 
        $('.location-dependent input').hide(); 
      }
    }
    else{
      $(this).parent(".ddbox").addClass("active");
      $(".dropdowns").show();
      $(".dropdowns input[type=radio]").on('click',function(event){
        $(".dropdowns").show();
        var text = $(this).next('span').text();
        //$(".ddbox").removeClass("active");

        $(".store-result").text(text);
        $("input[name='contact[location]']").val(text);
        $(".dropdowns span").removeClass("selected");
        $(this).next("span").addClass("selected");
        $(".dropdowns").hide();
        // event.preventDefault();
      });
    }
  });


  $(".dropdowns span").on('click',function(event){
    event.preventDefault();
    $(this).addClass("selected").prev('input').trigger("click");
    var location = $('input[name="contact[location]"]').val();

    if (location == 'Home or Office' ){
      $('.location-dependent').show();
      $('.location-dependent input').show();
    } else {
      $('.location-dependent').hide(); 
      $('.location-dependent input').hide(); 
    }
  });

  $(".dropdowns input[type=radio]:checked").trigger('click').next('span').trigger('click');
});